import styled from 'styled-components';

import {
  ButtonWrapper as AcceptTermsAndConditionsButtonWrapper,
  ContentWrapper as AcceptTermsAndConditionsContentWrapper,
} from '../../accept_terms_and_conditions/index.styles';

export {
  Footer,
  ScrollContainer,
  Wrapper,
} from '../../accept_terms_and_conditions/index.styles';

export const ContentWrapper = styled(AcceptTermsAndConditionsContentWrapper)`
  text-align: center;
`;

export const Icon = styled.div`
  margin: 2em auto 0;
`;

export const CheckIconWrapper = styled.div`
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #63d375;
  border-radius: 50%;

  svg {
    stroke: var(--white);
  }
`;

export const Name = styled.div`
  font-size: 24px;
  font-weight: 700;
`;

export const Price = styled.div`
  margin-bottom: 3.5em;
  line-height: 1.2;
`;

export const Amount = styled.span`
  display: block;
  font-size: 72px;
`;

export const Description = styled.p`
  margin: 3em auto 2em;
  white-space: pre-wrap;
`;

export const Hint = styled.p``;

export const ButtonWrapper = styled(AcceptTermsAndConditionsButtonWrapper)`
  a,
  button {
    flex-grow: 0;
  }
`;
